import * as React from "react";
import ContentCard from "../../../../ui-library/content-card/content-card";
import CardContent from "../../../../ui-library/content-card/card-content";
import { grid } from "../../../../design-tokens/grid";
import Image from "../../../../ui-library/image/image";
import styles from "./how-can-we-win.styles";
import ActionCard from "./action-card";
import CaseDistribution from "./case-distribution";
import ActionsCardGroup from "./actions-card-group";
import ECVLogo from "./assets/ecv-logo.jpg";

const HowCanWeWin: React.FC = () => {
  return (
    <ContentCard>
      <CardContent isNarrow={true}>
        <h2 css={styles.heading}>
          We can beat the virus together. It can be done in 5 weeks.
        </h2>
        <p css={styles.content}>
          Recognise the virus is a real threat and its impact on our lives is
          something we can’t ignore.
        </p>
      </CardContent>

      <CardContent isFullWidthOnMobile={true}>
        <ActionCard css={{ marginBottom: grid(4) }}>
          <h2 css={styles.heading}>
            Learn about the impact of our action or non-action. It all counts.
          </h2>
          <p css={styles.content}>
            COVID-19 is a rapidly transmitting disease requiring hospitalization
            in about 20% of cases, ICU care in 10%, and resulting in death in
            2-4%. We need to crush the curve and start today.
          </p>

          <div css={styles.graphContainer}>
            <div css={styles.graphs}>
              <CaseDistribution />
              <div css={styles.crushCurve} />
            </div>
          </div>
        </ActionCard>
      </CardContent>

      <CardContent isNarrow={true}>
        <h2 css={styles.heading}>
          We all need to take action to eliminate the virus.
        </h2>
        <p css={styles.content}>
          Lets crush the curve by taking effective action using these 9
          guidelines.
        </p>
      </CardContent>

      <CardContent isFullWidthOnMobile={true}>
        <ActionsCardGroup />
      </CardContent>

      <CardContent isNarrow={true}>
        <a
          css={styles.ecvLogo}
          href="https://www.endcoronavirus.org/all-guidelines"
          target="_blank"
          rel="noreferrer"
        >
          <Image src={ECVLogo} alt="EndCoronavirus.org" />
        </a>
      </CardContent>
    </ContentCard>
  );
};

export default HowCanWeWin;
